module.exports = __webpack_public_path__ + "img/bsjg_02.ce16e899.png";